import React, {useState, useEffect} from "react";
import {
    Tabs,
    Tab,
    Box,
} from "@mui/material";
import { useOutletContext, useSearchParams } from "react-router-dom";
import DocumentsTable from "../../components/Documents/documentsTable";
import DraftDocuments from "../../components/Documents/draftDocument";
import EsignedDocument from "../../components/Documents/esignedDocument";
import Templates from "../../components/Documents/template";
import { useSelector } from "react-redux";
import { useLogger } from "../../hooks/useLogger";

const Documents = () => {
  const logEvent = useLogger();
  const [searchParams] = useSearchParams();
  const { open } = useOutletContext();
  const [tabIndex, setTabIndex] = useState(0);

  const tabLabels = ['All Documents', 'Drafts', 'Templates', 'eSigned Documents'];
  const handleTabChange = (event, newValue) => {
    logEvent('tabclicked', tabLabels[newValue], 'Documents');
    setTabIndex(newValue);
  };

  useEffect(() => {
    const tabFromQuery = searchParams.get("activeTab");
    if (tabFromQuery && !isNaN(tabFromQuery)) {
      setTabIndex(parseInt(tabFromQuery, 10));
    }
  }, [searchParams]);
  
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: 3,
        width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
        marginLeft: open ? "240px" : "100px",
        transition: "margin 0.3s ease",
        height: "100vh",
        display: "flex",
        background: "#f9f9f9",
      }}
    >
      <Box
        mt={10}
        style={{
          borderRadius: "12px",
          textAlign: "center",
          background: "#fff",
          width: "100%",
          height: "calc(100% - 154px)",
          marginLeft: open ? "" : "1em",
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          sx={{ 
            borderBottom: 1, borderColor: "#1D1D1D1A", mb: 2, 
            "& .MuiTabs-indicator": {
              width: "180px",
              height: "4px",
              backgroundColor: "#185CB7",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px", color: "#185CB7"
            }, 
            "& .Mui-selected": 
            {
              color: "#185CB7 !important",
              fontWeight: "500"
            }
          }}
        >
          <Tab label="All Documents" sx={{ textTransform: "capitalize", padding: "20px 30px", fontSize: "16px", fontWeight: 400, color: "#1D1D1D", }} />
          <Tab label="Drafts" sx={{ textTransform: "capitalize", padding: "20px 30px", fontSize: "16px", fontWeight: 400, color: "#1D1D1D", }} />
          <Tab label="Templates" sx={{ textTransform: "capitalize", padding: "20px 30px", fontSize: "16px", fontWeight: 400, color: "#1D1D1D", }} />
          <Tab label="eSigned Documents" sx={{ textTransform: "none", padding: "20px 30px", fontSize: "16px", fontWeight: 400, color: "#1D1D1D", }} />
        </Tabs>
        {tabIndex === 0 && <DocumentsTable />}
        {tabIndex === 1 && <DraftDocuments />}
        {tabIndex === 2 && <Templates />}
        {tabIndex === 3 && <EsignedDocument />}
      </Box>
    </Box>
  );
};

export default Documents;
